import Permissions from "./permissions.service";

const permissionsModule = angular
  .module("app.services.permissions", [])
  .service("Permissions", Permissions);

export default permissionsModule;



// WEBPACK FOOTER //
// ./src/services/permissions/permissions.module.js